<template>
  <div class="carbon">
    <ListTitle :title="title" :titleImg="titleImg" />
    <Introduce title="碳匯知多少" @moveToCalculator="moveToCalculator" />
    <VideoPlayer
      title="樹木測量教學"
      videoId="yPiDgxSUc7A"
      videoTitle="碳匯相關教學影片"
    />
    <Calculator title="碳匯計算機" />
    <Footer />
  </div>
</template>
<script>
import ListTitle from "@/components/ui/searchList/ListTitle.vue";
import Introduce from "@/components/carbon/introduce.vue";
import VideoPlayer from "@/components/carbon/videoPlayer.vue";
import Calculator from "@/components/carbon/calculator.vue";
import Footer from "@/components/layouts/footer.vue";

export default {
  props: {
    title: {
      type: String,
      default: "碳匯專區"
    },
    titleImg: {
      type: String,
      default: "common/icon_carbon.svg"
    }
  },
  components: {
    ListTitle,
    Introduce,
    VideoPlayer,
    Calculator,
    Footer
  },
  methods: {
    moveToCalculator() {
      console.log("wwo");
      const element = document.getElementById("calculator");
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>

<style lang="scss" scoped>
.carbon {
  background-color: #f7f3eb;
}
</style>
